/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import dynamicComponent from './dynamicComponent';
const GenericComponentError = dynamicComponent(() =>
    import(/* webpackChunkName: "GenericComponentError" */ './components/componentError')
);

/**
 * Like a try catch for components, prevent the entire app to crash
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true, error, info });
    }

    render() {
        const { error, info, hasError } = this.state;
        const { renderError, children } = this.props;

        if (hasError) {
            // You can render any custom fallback UI
            return (
                <Choose>
                    <When condition={renderError && typeof renderError === 'function'}>{renderError(error, info)}</When>
                    <Otherwise>
                        <GenericComponentError error={error} info={info} />
                    </Otherwise>
                </Choose>
            );
        }
        return children;
    }
}

export default ErrorBoundary;
